import EditStepSwitcher from 'client/components/core/Sidebar/components/Settings/entities/two-step-payment-form-settings/edit-step-switcher'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import DeviceAppearanceNew from 'client/components/core/Sidebar/components/Settings/options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import Border from 'client/components/core/Sidebar/components/Settings/styles/Border'
import MarginStyle from 'client/components/core/Sidebar/components/Settings/styles/MarginStyle'
import PaddingStyle from 'client/components/core/Sidebar/components/Settings/styles/SplitPaddingStyle'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { TwoStepPaymentFormInterface } from 'common/types/entities/two-step-payment-form-interface'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'

export interface TwoStepPaymentFormSettingsProps {
  entity: TwoStepPaymentFormInterface
}

export const TwoStepPaymentFormSettings = ({
  entity,
}: TwoStepPaymentFormSettingsProps) => {
  const updateProp = useUpdateProp(entity)
  const { isMobile } = useDeviceModeContext()

  return (
    <React.Fragment>
      <EditStepSwitcher
        optInStepEntityId={entity.childIds?.[0]}
        paymentStepEntityId={entity.childIds?.[1]}
      />
      <GroupTitle>color</GroupTitle>
      <ColorPickerControl
        label="entity_settings.two_step_payment_form.background_color.label"
        update={updateProp('backgroundColor')}
        mobileUpdate={updateProp('mobileBackgroundColor')}
        color={entity.backgroundColor}
        mobileColor={entity.mobileBackgroundColor}
      />
      <ColorPickerControl
        label="entity_settings.two_step_payment_form.header_background_color.label"
        update={updateProp('headerBackgroundColor')}
        mobileUpdate={updateProp('mobileHeaderBackgroundColor')}
        color={entity.headerBackgroundColor}
        mobileColor={entity.mobileHeaderBackgroundColor}
      />
      <ColorPickerControl
        label="entity_settings.two_step_payment_form.header_text_color.label"
        update={updateProp('headerTextColor')}
        mobileUpdate={updateProp('mobileHeaderTextColor')}
        color={entity.headerTextColor}
        mobileColor={entity.mobileHeaderTextColor}
      />
      <ColorPickerControl
        label="entity_settings.two_step_payment_form.header_underline_color.label"
        update={updateProp('headerUnderlineColor')}
        mobileUpdate={updateProp('mobileHeaderUnderlineColor')}
        color={entity.headerUnderlineColor}
        mobileColor={entity.mobileHeaderUnderlineColor}
      />
      <ColorPickerControl
        label="entity_settings.two_step_payment_form.button_background_color.label"
        update={updateProp('buttonBackgroundColor')}
        mobileUpdate={updateProp('mobileButtonBackgroundColor')}
        color={entity.buttonBackgroundColor}
        mobileColor={entity.mobileButtonBackgroundColor}
      />
      <ColorPickerControl
        label="entity_settings.two_step_payment_form.button_color.label"
        update={updateProp('buttonTextColor')}
        mobileUpdate={updateProp('mobileButtonTextColor')}
        color={entity.buttonTextColor}
        mobileColor={entity.mobileButtonTextColor}
      />

      <Border
        border={entity.border}
        mobileBorder={entity.mobileBorder}
        update={updateProp('border')}
        mobileUpdate={updateProp('mobileBorder')}
      />
      <MarginStyle
        groupTitle
        margin={isMobile ? entity.mobileMargin : entity.margin}
        update={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <PaddingStyle
        groupTitle
        padding={isMobile ? entity.mobilePadding : entity.padding}
        update={updateProp(isMobile ? 'mobilePadding' : 'padding')}
      />

      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </React.Fragment>
  )
}
